import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=607055d7&scoped=true&"
import script from "./CustomIcon.vue?vue&type=script&lang=js&"
export * from "./CustomIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=607055d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607055d7",
  null
  
)

export default component.exports